import { render, staticRenderFns } from "./stadium_notice.vue?vue&type=template&id=6f40c3a4&scoped=true&"
import script from "./stadium_notice.vue?vue&type=script&lang=ts&"
export * from "./stadium_notice.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_notice.vue?vue&type=style&index=0&id=6f40c3a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40c3a4",
  null
  
)

export default component.exports